import request from 'assets/js/http';

// 运营组获取各角色人员列表
export function getGroupRoles(data) {
  return request({
    url: '/role/getGroupRoles',
    method: 'post',
    data
  });
}

// leader与member绑定（增）
// export function bindLeaderMember(data) {
//   return request({
//     url: '/land/bindLeaderMember',
//     method: 'post',
//     headers: {
//       'content-type': 'application/json'
//     },
//     data
//   });
// }

// 获取leader与member绑定关系(增)
// export function getBindRelations(data) {
//   return request({
//     url: '/land/getBindRelations',
//     method: 'post',
//     data
//   });
// }

// 运营组设置各角色人员列表（增）
export function setGroupRoles(data) {
  return request({
    url: '/role/setGroupRoles',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data
  });
}
